<template>
    <div class="col-md-8 main-content clearfix pt-3">
        <h3>{{news.title}}</h3>
        <div v-if="user.editor || user.admin">
            <span class="dropdown edit-dropdown top-right">
                <a href="#" data-toggle="dropdown" role="button" aria-expanded="false" aria-haspopup="true"
                   class="dropdown-toggle" style="" :title="$t('button.Edit')">
                    <i class="fas fa-pencil-alt big-icon"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                    <router-link :to="'/news/'+ news.slug + '/edit'" class="dropdown-item">{{ $t('button.Edit') }}</router-link>

                    <a @click="setAsTop" href="#" :class="disable ? 'dropdown-item disabled' : 'dropdown-item'">
                        <i :class="(news.is_featured ? 'fas' : 'far') + ' fa-star'"></i>
                        {{ news.is_featured ? $t('button.UnsetAsFeatured') : $t('button.SetAsFeatured') }}
                    </a>
                </div>
            </span>
        </div>
        <small>
          {{ $t('fields.lastChanged')}} {{ lastChanged | formatTime }}
          <div v-if="user.editor || user.admin">
            Videné: {{news.viewed}}
          </div>
        </small>
        <hr>
        <div v-if="!hideImage">
            <img v-lazy="news.image" class="center img-fluid">
        </div>
        <div v-html="news.body"></div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'NewsItem',
    props: ['hideImage'],
    data() {
      return {
        disable: false
      };
    },
    computed: {
      ...mapGetters(['user']),
      slug() {
        return this.$route.params.slug;
      },
      news() {
        return this.$store.state.news.detail[this.slug] || {};
      },
      lastChanged() {
        const date = this.news.updated_at || this.news.created_at;
        return date;
      }
    },
    methods: {
      ...mapActions(['editNews']),
      setAsTop(e) {
        e.preventDefault();
        if (this.disable) return;
        this.disable = true;

        this.editNews({
          ...this.news,
          is_featured: !this.news.is_featured
        })
          .then((response) => {
            this.disable = false;
            if (response.news.status == 'published') {
              this.$router.push('/?p=1');
            } else {
              this.$router.push('/news-list/unpublished');
            }
          })
          .catch(() => {
            this.$router.push('/error');
          });
      }
    }
  };
</script>

<style scoped>

</style>
